import ISearch from "../types/search";

export const createDefaultSearch = (): ISearch => {
  return { text: "", toDate: "", fromDate: "" };
};
